import { render, staticRenderFns } from "./DashboardAchievement.vue?vue&type=template&id=1a43db80"
import script from "./DashboardAchievement.vue?vue&type=script&lang=js"
export * from "./DashboardAchievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports